import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ILabel } from '../ILabel.model';
import { FileInputType } from '../cpq-file-select-with-filesystem/file.model';
import { SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MessagesService } from '../common/services/messages.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslationService } from '../common/services/translation.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';
import { downloadFile } from '../common/functions/file-helpers';
import { ValueAccessorBase } from '../value-accessor-base';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'cpq-file-select',
    templateUrl: './cpq-file-select.component.html',
    styleUrls: ['./cpq-file-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CpqFileSelectComponent,
            multi: true
        }
    ],
    standalone: false
})
export class CpqFileSelectComponent extends ValueAccessorBase<any> implements OnInit {

  @Input('label') label: ILabel;
  @Input('multiple') multiple: boolean = false;
  @Input('accept') accept: string;
  @Input('allowedExtensions') allowedExtensions?: Array<string>;
  @Output('onDownload') onDownload: EventEmitter<any> = new EventEmitter<any>();

  public FileInputType = FileInputType;
  public previewLoaded: boolean;
  public filePath: SafeUrl;
  public allowedExtensionsInfo: string;
  public fileName: string;
  constructor(public route: ActivatedRoute,
    public messagesService: MessagesService,
    public dialog: MatDialog,
    private translateService: TranslationService) {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.allowedExtensions && this.allowedExtensions.length > 0) {
      this.allowedExtensionsInfo = `(${this.allowedExtensions.join(', ')})`;
    }
  }

  onFileSelected(event) {
    const files = event.target.files;
    if (files.length > 0) {
      if (this.allowedExtensions && this.allowedExtensions.length > 0) {
        if (!this.checkIfFileExtensionIsAllowed(files[0].name)) {
          this.dialog.open(AlertDialogComponent, {
            data: {
              content: this.translateService.translate('Util.Fileupload.MsgSelectedFileExtensionIsForbidden')
            }
          });
          return;
        }
      }

      this.value = this.multiple ? files : files[0];
      this.fileName = this.multiple ? "" : this.value.name;
    }
  }

  checkIfFileExtensionIsAllowed(fileName) {
    const fileExtension: string = (fileName).substring(fileName.lastIndexOf('.'));
    if (this.allowedExtensions.map(extension => extension.toLocaleUpperCase()).indexOf(fileExtension.toLocaleUpperCase()) === -1) {
      return false;
    }
    return true;
  }

  download() {
    if (!this.value) {
      return;
    }

    const blob = new Blob([this.value], { type: this.value.type });
    downloadFile(this.value.name, blob, '');
  }

  remove() {
    this.value = null;
  }
}
